import moment from 'moment';
import {extendMoment} from 'moment-range';

const momentPatched = extendMoment(moment);

if (typeof window !== 'undefined') {
  window.moment = momentPatched; // eslint-disable-line no-restricted-syntax
}

export default momentPatched;
